import {useDispatch, useSelector} from "react-redux";
import React, {useCallback, useEffect} from "react";
import {loadBrandMonthList} from "../../../../redux/slices/dynamicMultipleElementsSlice";
import {ComponentNoData} from "../../../../components/ComponentLoader";
import ScrollLayout from "../../../../components/ScrollLayout";
import BrandCard from "./BrandCard";
import BrandLoader, {BrandError} from "./BrandLoader";
import {safeImage} from "../../../../helpers/helperFunctions";

const BrandMonth = ({section, mobile = true}) => {
  const {[section.value]: brandMonth} =
    useSelector((state) => state.dynamicMultipleElements.brandMonth);

  return (
    <MemoizedBrandMonthContent brandMonth={brandMonth} section={section} mobile={mobile}/>
  );
};

export default React.memo(BrandMonth);

const BrandMonthContents = ({
                              brandMonth: {loading, data, init = false, error, hasNext, meta} = {},
                              section,
                              mobile
                            }) => {

  const dispatch = useDispatch();

  const loadMore = useCallback((force = false) => {
    if (force || (hasNext && !loading && !error))
      dispatch(loadBrandMonthList(section.value));
  }, [hasNext, loading, error, section]);

  useEffect(() => {
    if (!init && !error && !loading) {
      dispatch(loadBrandMonthList(section.value));
    }
  }, [init, loading, error]);

  return (
    <div className="app-side-pd">
      <div className="w-full app-top-mg grid">
        <div className={`grid-area w-full overflow-hidden ${mobile ? "aspect-focused-banner" : "aspect-ratio-special-banner_web"}`}>
          <img src={`${meta?.images ? safeImage(meta.images) : ''}`} alt="" className="w-full h-full app-rounded object-cover"/>
        </div>
        <div className="relative grid-area min-w-0">
          <div className={`${mobile ? "h-[78px] text-xs mx-5 pt-5 mb-2.5" : "h-[100px] text-base mx-24 pt-6 mb-4"} text-rand-100 text-right`}>
            View all
          </div>
          {(init && !data?.length) ?
            <ComponentNoData/> :
            <ScrollLayout className="brand-list" onScroll={loadMore} showNav={!mobile}>

              {data?.map((d) => <BrandCard brand={d} key={d.id} isFeatured={true}/>)}

              {Array.from({length: !init && !error ? 10 : loading ? 2 : 0}, (_, i) =>
                <BrandLoader key={`all-campaign-month-brand-loader-${i}`} isFeatured={true}/>)}
              {error && <BrandError retry={() => loadMore(true)} errorMsg={error} isFeatured={true}/>}

            </ScrollLayout>}
        </div>


      </div>
    </div>
  );
};


const MemoizedBrandMonthContent = React.memo(BrandMonthContents);